import React, { useState } from 'react';
import {
    Container,
    Typography,
    Card,
    CardContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Paper,
    Grid,
    IconButton,
    Button,
    Box,
    Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../Auth/AuthProvider';
import { can } from '../../Conections/LogConections';
import { GetActivityDataAPI, GetEstudentsDataAPI, GetGruopDataAPI } from '../../Conections/AcademicConection';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

// Datos de ejemplo
const actividadEjemplo = {
    id: '0',
    nombre: "",
    descripcion: "",
    fecha: "",
    peso: 0
};

const estudiantesEjemplo = [
    { id: 0, codigo: '', nombre: "", apellido: "" },
];

const grupoEjemplo = {
    id: '',
    nombre: '',
    descripcion: '',
    estado: true,
};

function GradeUpOne() {

    const goTo = useNavigate();
    const { getToken, getCompany } = useAuth();
    const params = useParams();

    const [grupo, setGrupo] = useState(grupoEjemplo);
    const [actividad, setActividad] = useState(actividadEjemplo);
    const [estudiantes, setEstudiantes] = useState(estudiantesEjemplo);
    const [actividadTitle, setActividadTitle] = useState("");
    const [seleccionados, setSeleccionados] = useState({});
    const [openSnackbar, setOpenSnackbar] = useState(false);

    React.useEffect(() => {
        async function reloaduser() {
            if (getToken()) {
                const permisionCan = await can(getToken(), getCompany(), "/academic/gradeupone/:activity");
                if (permisionCan === 0) {
                    goTo("/dashboard");
                }
                else {
                    let Activity = await GetActivityDataAPI(getToken(), getCompany(), params["activity"]);
                    let Estudents = await GetEstudentsDataAPI(getToken(), getCompany(), Activity["group"]);
                    let Gruop = await GetGruopDataAPI(getToken(), getCompany(), Activity["group"]);
                    let grupoC = grupo;
                    grupoC["id"] = Gruop["gruop"]["id"];
                    grupoC["nombre"] = Gruop["gruop"]["name"];
                    grupoC["descripcion"] = Gruop["gruop"]["descripcion"];
                    grupoC["estado"] = Gruop["gruop"]["show"] === 1;
                    setGrupo(grupoC);

                    let actividadChange = actividad;
                    actividadChange["id"] = Activity["id"];
                    setActividadTitle(Activity["name"]);
                    actividadChange["nombre"] = Activity["name"];
                    actividadChange["descripcion"] = Activity["description"];
                    actividadChange["peso"] = Activity["weigth"];
                    actividadChange["fecha"] = Activity["date"];
                    actividadChange["activa"] = Activity["show"] === 1;
                    setActividad(actividadChange);

                    const listEstudents = Estudents.map(Estudent => ({
                        id: Estudent.id,
                        codigo: Estudent.code,
                        nombre: Estudent.firstname,
                        apellido: Estudent.lastname
                    }));
                    setEstudiantes(listEstudents);
                }
            }
            else {
                goTo(`/login`);
            }
        };
        reloaduser();
    }, [params, actividad, getCompany, getToken, goTo, actividadTitle]);

    const handleSeleccionChange = (event, id) => {
        setSeleccionados(prev => ({
            ...prev,
            [id]: event.target.checked
        }));
    };

    const handleEnviarSeleccionados = () => {
        const idsSeleccionados = Object.keys(seleccionados).filter(id => seleccionados[id]);
        goTo("/academic/gradeuptwo/" + actividad["id"], { state: { idsSeleccionados } });
        setOpenSnackbar(true);
    };

    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnackbar(false);
    };

    const handleVerResultados = () => {
        goTo(`/academic/gradeshow/${actividad.id}`);
    };

    const handleSubirNotas = () => {
        goTo(`/academic/gradeup/${actividad.id}`);
    };

    const handleGrupo = () => {
        goTo("/academic/showgroup/" + grupo.id);
    };

    const handlePrincipal = () => {
        goTo("/academic/showactivity/" + actividad.id);
    };

    return (
        <Container maxWidth="lg">
            <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ my: 4 }}>
                Seleccionar Estudiantes para Calificación
            </Typography>

            <Grid container spacing={3} direction="column">
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                <IconButton onClick={() => handleGrupo()} color="primary">
                                    <PeopleOutlineIcon />
                                </IconButton>
                                Datos de la Grupo
                            </Typography>
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {grupo.nombre}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Descripción:</strong> {grupo.descripcion}
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                <IconButton onClick={() => handlePrincipal()} color="primary">
                                    <ArrowBackIosIcon />
                                </IconButton>
                                Datos de la Actividad
                            </Typography>
                            <Typography variant="body1">
                                <strong>Nombre:</strong> {actividad.nombre}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Descripción:</strong> {actividad.descripcion}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Fecha:</strong> {actividad.fecha}
                            </Typography>
                            <Typography variant="body1">
                                <strong>Peso:</strong> {actividad.peso}%
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleVerResultados}
                                    sx={{ mt: 2 }}
                                >
                                    Ver Resultados
                                </Button>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={handleSubirNotas}
                                    sx={{ mt: 2 }}
                                >
                                    Subir notas
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="h6" gutterBottom>
                                Lista de Estudiantes
                            </Typography>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    indeterminate={
                                                        Object.values(seleccionados).some(Boolean) &&
                                                        !Object.values(seleccionados).every(Boolean)
                                                    }
                                                    checked={Object.values(seleccionados).every(Boolean)}
                                                    onChange={(event) => {
                                                        const newSeleccionados = estudiantes.reduce((acc, estudiante) => {
                                                            acc[estudiante.id] = event.target.checked;
                                                            return acc;
                                                        }, {});
                                                        setSeleccionados(newSeleccionados);
                                                    }}
                                                />
                                            </TableCell>
                                            <TableCell>Código</TableCell>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Apellido</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {estudiantes.map((estudiante) => (
                                            <TableRow key={estudiante.id}>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={!!seleccionados[estudiante.id]}
                                                        onChange={(event) => handleSeleccionChange(event, estudiante.id)}
                                                    />
                                                </TableCell>
                                                <TableCell>{estudiante.codigo}</TableCell>
                                                <TableCell>{estudiante.nombre}</TableCell>
                                                <TableCell>{estudiante.apellido}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleEnviarSeleccionados}
                                    disabled={!Object.values(seleccionados).some(Boolean)}
                                >
                                    Enviar Seleccionados
                                </Button>
                            </Box>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    Estudiantes seleccionados enviados exitosamente!
                </Alert>
            </Snackbar>
        </Container>
    );
}

export default GradeUpOne;

